export const getCategoryCardDetails = (cardData) => {
    const categoryTitle = cardData?.tag?.tag || '';
    const categoryImage = cardData?.tag?.coverIcon;
    return {categoryTitle, categoryImage};
}